import { useSelector } from "react-redux";
import {
  getQuestionById,
  getQuestionsAndAnswers
} from "../../../../store/selectors";
import { useDispatch } from "react-redux";
import {
  QuestionIds,
  questionPresentationContent,
  questionRoutingLabels,
  yesMaskValue
} from "../../../../data/QuestionPresentation";
import { appraisalSlice } from "../../../../store/slices/Appraisal";
import { useNavigate } from "react-router-dom";
import { sendEvent, setAnalyticsLabel } from "../../../../helpers/analytics";

function useTyres() {
  const QUESTION_ID = QuestionIds.TYRES;
  const NEXT_QUESTION_PATH = questionRoutingLabels[QuestionIds.WHEELS];

  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const answer = questionsAndAnswers && questionsAndAnswers[QUESTION_ID];
  const conditionQuestion = useSelector(
    getQuestionById("Condition", QUESTION_ID)
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    pageTitle,
    questionTooltip
  } = questionPresentationContent[QUESTION_ID];

  const handleSubmit = (answers: number[] | null) => {
    const answer = answers && answers[0];
    if (answer === yesMaskValue) {
      return dispatch(appraisalSlice.actions.setQuestionValidation("select"));
    }
    if (!answer) {
      return dispatch(appraisalSlice.actions.setQuestionValidation("radio"));
    }
    const photoQty = conditionQuestion.answers.find((a: { id: string }) => {
      return a.id.toString() === answer.toString();
    })?.imageQuantityRequired;
    dispatch(
      appraisalSlice.actions.setPhotosRequired({ [QUESTION_ID]: photoQty })
    );
    sendEvent("event", "interaction", {
      action: conditionQuestion.content,
      label: setAnalyticsLabel(conditionQuestion, answer),
    });
    navigate(`/${NEXT_QUESTION_PATH}`);
  };

  return {
    question: conditionQuestion,
    questionTooltip,
    questionTitle: conditionQuestion.content,
    pageTitle,
    handleSubmit,
    answer
  };
}

export default useTyres;
